/* eslint-disable no-param-reassign */
/* eslint-disable func-names */
export default {
	bind(el, binding, vnode) {
		el.clickOutsideEvent = function (event) {
			// Check if the click was outside the element and its children
			// Also, check if the click is not on the toggle button
			const toggleButton = document.querySelector('.mega-menu-toggle'); // Change selector if needed
			const toggleMobileButton = document.querySelector('.mega-mobile-menu-toggle'); // Change selector if needed
			const isDesktop = (toggleButton && toggleButton.contains(event.target));
			const isMobile = (toggleMobileButton && toggleMobileButton.contains(event.target));
			if (!(el === event.target || el.contains(event.target) || isDesktop || isMobile)) {
				// Call the method provided in the directive's value
				vnode.context[binding.expression](event);
			}
		};
		document.body.addEventListener('click', el.clickOutsideEvent);
	},
	unbind(el) {
		document.body.removeEventListener('click', el.clickOutsideEvent);
	},
};
